import type { Content } from '@prismicio/client';

import type { EnrichedHeaderDocument } from '@/types';

type HeaderAction = Content.HeaderDocumentDataActionsSlice;

/** Returns the first active slice of the given type from the Header "Actions" tab. */
export const getHeaderAction = <TType extends HeaderAction['slice_type']>(
  header: EnrichedHeaderDocument | undefined,
  sliceType: TType,
) => {
  const actions: HeaderAction[] = header?.data?.actions ?? [];

  return actions.find(
    (slice): slice is Extract<HeaderAction, { slice_type: TType }> =>
      slice.slice_type === sliceType && Boolean(slice.primary?.active),
  );
};
